// extracted by mini-css-extract-plugin
module.exports = {"mainMenu":"MainMenu_mainMenu__1f7EV","mainMenuHeader":"MainMenu_mainMenuHeader__359lg","divider":"MainMenu_divider__o8krG","mainMenuItemList":"MainMenu_mainMenuItemList__33Yja"};